import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';
import { AppConfig } from '../configuration/app.config';
import { LivesApiCredentials } from '../../../assets/config/livesApiCredentials';
import { LivesSessionHelper } from '../helper/livesSessionHelper';

@Injectable()
export class AppSecurityService {
    constructor(
        private http: HttpClient,
        private _livesSession: LivesSessionHelper,
    ) { }

    getManagement(): Observable<any> {
        if (!AppConfig.settings) {
            throw new Error('[AppSecurityService] Configuración no cargada');
        }

        const url = `${AppConfig.settings.apiServerPE.apiUrl}auth/management`;

        const body = {
            adminName: LivesApiCredentials.adminName,
            password: LivesApiCredentials.password
        };

        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json-patch+json')
            .set('accept', 'text/plain')
            .set('X-API-KEY', AppConfig.settings.apiServerPE.apiKey)
            .set('X-Skip-Interceptor', 'true');


        return this.http.post<any>(url, body, { headers });
    }

    getAuthAndRefresh(managementToken: string, clientId: string, aspNetUserId: any): Observable<any> {
        if (!AppConfig.settings) {
            throw new Error('[AppSecurityService] Configuración no cargada');
        }

        const url = `${AppConfig.settings.apiServerPE.apiUrl}auth/initialize/web`;

        const body = {
            clientId,
            sourceType: 'WEB',
            aspNetUserId
        };

        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json-patch+json')
            .set('accept', 'text/plain')
            .set('Authorization', `Bearer ${managementToken}`)
            .set('X-API-KEY', AppConfig.settings.apiServerPE.apiKey)
            .set('X-Skip-Interceptor', 'true');


        return this.http.post<any>(url, body, { headers });
    }

    refreshAuth(): Observable<any> {
        if (!AppConfig.settings) {
            throw new Error('[AppSecurityService] Configuración no cargada');
        }

        const url = `${AppConfig.settings.apiServerPE.apiUrl}auth/refresh`;

        const headers = new HttpHeaders()
            .set('accept', 'text/plain')
            .set('X-API-KEY', AppConfig.settings.apiServerPE.apiKey)
            .set('X-Skip-Interceptor', 'true');

        return this.http.post<any>(url, {}, { headers, withCredentials: true });
    }

    renewToken(clientId: string, aspNetUserId: any): Observable<string> {
        if (!AppConfig.settings) {
            throw new Error('[AppSecurityService] Configuración no cargada');
        }

        // Si no hay refreshToken, ir directamente a management
        if (!this._livesSession.LivesAccessToken) {
            console.warn('[renewToken] No hay LivesAccessToken, iniciando con getManagement...');
            return this.getManagement().pipe(
                switchMap(mgmt => {
                    console.warn('[renewToken] getManagement OK, haciendo getAuthAndRefresh...');
                    return this.getAuthAndRefresh(mgmt.data.managementToken, clientId, aspNetUserId);
                }),
                map(auth => {
                    console.warn('[renewToken] getAuthAndRefresh OK');
                    return auth.data.accessToken;
                }),
                catchError(authError => {
                    console.error('[renewToken] Error al hacer getAuthAndRefresh:', authError);
                    throw new Error('[renewToken] Falló el proceso completo sin refresh token');
                })
            );
        }

        // Si hay refreshToken, se intenta primero refrescar
        console.warn('[renewToken] Intentando refrescar el token...');
        return this.refreshAuth().pipe(
            map(auth => {
                console.warn('[renewToken] Token refrescado correctamente');
                return auth.data.tokens.accessToken;
            }),
            catchError(refreshError => {
                console.error('[renewToken] Error al refrescar token:', refreshError);
                console.warn('[renewToken] Intentando obtener nuevo token desde getManagement...');

                return this.getManagement().pipe(
                    switchMap(mgmt => {
                        console.warn('[renewToken] getManagement OK, haciendo getAuthAndRefresh...');
                        return this.getAuthAndRefresh(mgmt.data.managementToken, clientId, aspNetUserId);
                    }),
                    map(auth => {
                        console.warn('[renewToken] getAuthAndRefresh OK');
                        return auth.data.accessToken;
                    }),
                    catchError(authError => {
                        console.error('[renewToken] Error al hacer getAuthAndRefresh:', authError);
                        throw new Error('[renewToken] Falló el proceso completo de renovación de token');
                    })
                );
            })
        );
    }



}
